<template>
  <div
    :key="boardListId"
    class="list-title-count-wrap"
  >
    <em
      class="board-list-status"
      :style="{ ...boardListIconStyle }"
    />
    <span class="list-title">
      {{ boardListTitle }}
    </span>
    <span class="cards-count">
      {{ totalCards }}
    </span>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'ListOfBoardsItemListTitleContent',

  mixins: [customIconsMixin],

  props: {
    boardListId: {
      type: String,
      required: true,
    },
    boardListTitle: {
      type: String,
      required: true,
    },
    totalCards: {
      type: Number,
      required: false,
      default: 0,
    },
    boardListIconStyle: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
$statusIconDim: 16px;

.list-title-count-wrap {
  max-width: $columnWidth;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  text-overflow: ellipsis;
  align-items: center;

  .board-list-status {
    min-height: $statusIconDim;
    max-height: $statusIconDim;
    min-width: $statusIconDim;
    max-width: $statusIconDim;
  }
  .list-title,
  .cards-count {
    font-size: 14px;
    line-height: $listTitleHeight;
  }

  .list-title {
    @apply truncate ml-1 text-text-default;
  }

  .cards-count {
    @apply text-inactive-text ml-2;
  }

  div {
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;

    span {
      text-overflow: ellipsis;
    }

    + div {
      flex-grow: 1;
      flex-shrink: 0;
      margin-left: 6px;
    }
  }
}
</style>
